import { AxiosError } from 'axios';
import {
  QueryFunction,
  QueryKey,
  UseBaseQueryOptions,
  useQueries as useQueriesDefault,
  useQuery as useQueryDefault,
} from 'react-query';

import { APIError } from '@customTypes/api/Error';

const useQuery = <TQueryFnData>(
  queryKey: QueryKey,
  queryFn: QueryFunction<TQueryFnData>,
  options?: Omit<
    UseBaseQueryOptions<TQueryFnData, APIError>,
    'queryKey' | 'queryFn'
  >,
) => useQueryDefault<TQueryFnData, APIError>(queryKey, queryFn, options);

const useQueries = <TQueryFnData>(
  options: UseBaseQueryOptions<TQueryFnData, AxiosError>[],
) =>
  useQueriesDefault<UseBaseQueryOptions<TQueryFnData, AxiosError>[]>(options);

export { useQuery, useQueries };
